import * as _ from 'lodash';

console.error = (function () {
  const error = console.error;
  const ignoredErrorMessages = [
    'Warning: A component is `contentEditable`',
    'Warning: string refs are not supported on children of TransitionGroup',
    'isMounted is deprecated',
  ];

  return function (exception, ...args) {
    if (_.every(ignoredErrorMessages, (errorMsg) => (exception + '').indexOf(errorMsg) < 0)) {
      error.apply(console, [exception, ...args]);
    }
  };
})();

Error.stackTraceLimit = Infinity;
